// extracted by mini-css-extract-plugin
module.exports = {"error__text":"HomePageError_error__text__2HTmc","clear_float":"HomePageError_clear_float__2DFzm"};